
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HEADER_ORIGIN_STORAGE_KEY } from 'app/shared/utils/article-header-origin';
import { ArticleService } from 'app/home/article/article.service';
// import { OwlOptions } from 'ngx-owl-carousel-o';
import { setting } from '../../../../setting';
import { Router } from '@angular/router';
import { InfiniteCarousel } from 'app/shared/utils/infinite-carousel';

interface DestinationArticleExtras {
  photos: string[];
  titleInfo: { title: string; description: string }[];
}

@Component({
  selector: 'usb-destination-big',
  templateUrl: './destination-big.component.html',
  styleUrls: ['./destination-big.component.scss']
})
export class DestinationBigComponent implements OnInit {
  @Input() getClientsSettingAppBooking: any;
  public sectionDestinationBig: any;
  public routeUploadFile:any;
  destinations: any = [];
  linkArticle = [
    { url: '#/article-one' },
    { url: '#/article-two' },
    { url: '#/article-three' }
  ];

  carousel = new InfiniteCarousel<any>();

  // Cámara y comentario traen las fotos/títulos-y-descripciones del artículo al que apunta esa
  // tarjeta (misma consulta que usa usb-article), no los datos de la tarjeta en sí. Se cachea
  // por id de artículo: si ya se pidió para uno de los dos íconos, el otro lo reutiliza.
  private articleExtrasCache: { [articleId: number]: DestinationArticleExtras } = {};
  public commentTooltipText: { [articleId: number]: string } = {};

  imageLightboxOpen: boolean = false;
  imageLightboxImages: string[] = [];
  imageLightboxIndex: number = 0;

  // Carrusel anterior (ngx-owl-carousel-o), se mantiene comentado hasta confirmar el nativo.
  // customOptions: OwlOptions = {
  //   loop: true,
  //   mouseDrag: false,
  //   touchDrag: false,
  //   pullDrag: false,
  //   dots: false,
  //   navSpeed: 700,
  //   navText: ['<i class="bi bi-chevron-left"></i>', '<i class="bi bi-chevron-right" style="font-size: 50px"></i>'],
  //   responsive: {
  //     0: {
  //       items: 1
  //     },
  //     400: {
  //       items: 2
  //     },
  //     740: {
  //       items: 2
  //     },
  //     940: {
  //       items: 2
  //     },
  //     1140: {
  //       items: 2
  //     },
  //     1340: {
  //       items: 2
  //     },
  //     1540: {
  //       items: 2
  //     },
  //     1740: {
  //       items: 2
  //     },
  //     1940: {
  //       items: 2
  //     }
  //   },
  //   nav: true
  //   }



  constructor( private router: Router, private articleService: ArticleService) {
    // this.getClientsSettingAppBooking =  JSON.parse((localStorage.getItem(setting.name)));
    this.routeUploadFile =  setting.routeUploadFile;
   // console.log("llegando al destination-big component", this.getClientsSettingAppBooking);

   }

  ngOnInit() {
    this.sectionDestinationBig  = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_destination_big);
    for (let index = 0; index < this.sectionDestinationBig?.info.length; index++) {
      this.destinations[index] =
      {
        image: this.routeUploadFile + this.sectionDestinationBig?.info[index].image,
        title: this.sectionDestinationBig?.info[index].title,
        subtitle:  this.sectionDestinationBig?.info[index].subtitle,
        description:  this.sectionDestinationBig?.info[index].description,
        url: this.linkArticle[index].url
      }
    }

    this.carousel.setViewportWidth(window.innerWidth);
    this.carousel.setItems(this.destinations);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.carousel.setViewportWidth(window.innerWidth);
  }

  // ngAfterViewInit del carrusel anterior (ajustaba el tamaño de las flechas de owl-carousel-o).
  // ngAfterViewInit(): void {
  //   setTimeout(() => {
  //     const leftArrow = document.querySelector('.owl-prev') as HTMLElement;
  //     const rightArrow = document.querySelector('.owl-next') as HTMLElement;
  //     if (leftArrow) leftArrow.style.fontSize = '50px !important';
  //     if (rightArrow) rightArrow.style.fontSize = '50px !important';
  //   }, 0);
  // }

  articleRedirect(index: number): void {
    const typeArticle = 'big'; // Aquí puedes configurar la variable small como necesites
    const id = index; // Usar el índice o el id que se pase como parámetro
    const active = 0
    // Manda la imagen/título/descripción de la tarjeta clickeada para que el header del
    // artículo los use directo, sin tener que volver a pedirlos a la API. sessionStorage (no
    // router state) porque tiene que sobrevivir a un refresh de la página del artículo.
    const destination = this.destinations[index - 1];
    if (destination) {
      sessionStorage.setItem(HEADER_ORIGIN_STORAGE_KEY, JSON.stringify({
        typeArticle,
        id,
        image: destination.image,
        title: destination.title,
        description: destination.description
      }));
    }
    this.router.navigate([`/article/${typeArticle}/${id}/${this.getClientsSettingAppBooking.id}/${active}`]);
  }

  openImageLightbox(articleId: number, event: MouseEvent): void {
    event.stopPropagation();
    this.loadArticleExtras(articleId, (extras) => {
      this.imageLightboxImages = extras.photos;
      this.imageLightboxIndex = 0;
      this.imageLightboxOpen = true;
    });
  }

  onLightboxImageError(event: Event): void {
    console.error('No se pudo cargar la foto del lightbox:', (event.target as HTMLImageElement)?.src);
  }

  closeImageLightbox(event?: MouseEvent): void {
    event?.stopPropagation();
    this.imageLightboxOpen = false;
  }

  imageLightboxPrev(event: MouseEvent): void {
    event.stopPropagation();
    this.imageLightboxIndex = (this.imageLightboxIndex - 1 + this.imageLightboxImages.length) % this.imageLightboxImages.length;
  }

  imageLightboxNext(event: MouseEvent): void {
    event.stopPropagation();
    this.imageLightboxIndex = (this.imageLightboxIndex + 1) % this.imageLightboxImages.length;
  }

  // El texto del tooltip se muestra con show() manual (triggers="") para poder actualizarlo
  // recién cuando llega la respuesta de la consulta del artículo. show() se llama en un
  // setTimeout: si se llama en el mismo ciclo en que se actualiza [tooltip], Angular todavía
  // no propagó ese cambio al directive, entonces show() usa el valor viejo (vacío la primera
  // vez) — por eso hacía falta un segundo click, y por eso la posición también salía mal
  // (se calculaba contra el tooltip vacío/sin contenido).
  onCommentClick(articleId: number, tooltipRef: { show: () => void }, event: MouseEvent): void {
    event.stopPropagation();
    if (!this.commentTooltipText[articleId]) {
      this.commentTooltipText[articleId] = 'Cargando…';
    }
    setTimeout(() => tooltipRef.show());
    this.loadArticleExtras(articleId, (extras) => {
      const first = extras.titleInfo[0];
      this.commentTooltipText[articleId] = first
        ? `${first.title} — ${first.description}`
        : 'Sin información disponible.';
    });
  }

  @HostListener('document:keydown.escape')
  onImageLightboxEscape(): void {
    if (this.imageLightboxOpen) {
      this.imageLightboxOpen = false;
    }
  }

  private loadArticleExtras(articleId: number, callback: (extras: DestinationArticleExtras) => void): void {
    const cached = this.articleExtrasCache[articleId];
    if (cached) {
      callback(cached);
      return;
    }

    this.articleService.getArticle(2, articleId, this.getClientsSettingAppBooking.id).subscribe({
      next: (res: any) => {
        const det = res?.det;
        if (!det) {
          return;
        }
        const photosObj = det.photos ? JSON.parse(det.photos) : {};
        const titleObj = det.title ? JSON.parse(det.title) : { info: [] };
        const relationatedObj = det.relationated ? JSON.parse(det.relationated) : { info: [] };
        const galleryPhotos = (Object.values(photosObj) as string[]).map((photo) => this.routeUploadFile + photo);
        // Mezclamos las fotos de la galería con las de los artículos relacionados para que el
        // lightbox muestre más cantidad de imágenes.
        const relatedPhotos = ((relationatedObj.info || []) as { image?: string }[])
          .filter((relation) => !!relation.image)
          .map((relation) => this.routeUploadFile + relation.image);
        const extras: DestinationArticleExtras = {
          photos: [...galleryPhotos, ...relatedPhotos],
          titleInfo: titleObj.info || []
        };
        this.articleExtrasCache[articleId] = extras;
        callback(extras);
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

}
